import axios from 'axios';
import { apiUrl } from '@/constants/config'

const apiCliente =  axios.create({
    baseURL: apiUrl,
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }
});

export default {
    /**
     * Seguridad
    */
    userInfo(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/seguridad/userinfo`);
    },

    findUserByUsername(ndocumento){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/seguridad/buscar/${ ndocumento }`);
    },

    reset(id, payload){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.put(`/v1/seguridad/resetear/${ id }`, payload);
    },

    /**
     * Personal
    */
    findAllCargos(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/personal/cargos`);
    },

    createCargo(cargo){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.post(`/v1/personal/cargos/crear`, cargo);
    },
    
    updateCargo(id, cargo){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.put(`/v1/personal/cargos/editar/${ id }`, cargo);
    },

    deleteCargo(id){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.delete(`/v1/personal/cargos/eliminar/${ id }`);
    },

    selectionCargos(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/personal/cargos/seleccionar`);
    },

    selectionProfiels(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/personal/perfiles/seleccionar`);
    },

    selectionOficinas(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/personal/oficinas/seleccionar`);
    },

    getAllPersonal(page, size){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/personal?page=${ page - 1 }&size=${ size }`);
    },

    consultPersona(ndocumento){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/personal/consultar/${ ndocumento }`);
    },
    
    createPersona(data){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.post(`/v1/personal/crear`, data);
    },

    searchPersona(termino, page, size){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/personal/buscar/${termino}?page=${ page - 1 }&size=${ size }`);
    },

    findPersonaById(id){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/personal/mostrar/${ id }`);
    },
    
    disabledPersona(id){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.delete(`/v1/personal/bloquear/${ id }`);
    },

    updatePersona(id, data){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.put(`/v1/personal/editar/${ id }`, data);
    },
    
    asigningMetas(id, metas){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.post(`/v1/personal/asignar/${ id }`, metas);
    },
    
    findAllByMetaId(id){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/personal/meta/${ id }`);
    },

    notificar(id){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.post(`/v1/personal/notificar/${ id }`);
    },

    listarUnidadEjecutora(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/personal/ejecutoras`);
    },

    listarUnidadEjecutoraHabilitados(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/personal/ejecutoras/habilitados`);
    },

    listarUnidadEjecutoraInhabilitados(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/personal/ejecutoras/inhabilitados`);
    },

    habilitarUnidadEjecutora(id){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.post(`/v1/personal/ejecutoras/habilitar/${ id }`);
    },

    inhabilitarUnidadEjecutora(id){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.post(`/v1/personal/ejecutoras/inhabilitar/${ id }`);
    },

    eliminarUnidadEjecutora(id){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.delete(`/v1/personal/ejecutoras/eliminar/${ id }`);
    },

    seleccionarUnidadEjecutora(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/personal/ejecutoras/seleccionar`);
    },

    /**
     * Metas - SecFunc
    */
    findAllAniosEjecucion(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/metas/anios/seleccion`); 
    },

    findAllMetas(value){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/metas?anio=${ value }`);
    },

    assignedMetas(id){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/metas/asignados/${ id }`);
    },

    inhabilitar(id){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/metas/inhabilitar/${ id }`);
    },
    listarMetasHabilitados(value){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/metas/habilitados?anio=${ value }`);
    },

    listarMetasInhabilitados(value){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/metas/inhabilitados?anio=${ value }`);
    },

    habilitar(id){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/metas/habilitar/${ id }`);
    },

    sincronizar(value){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/metas/sincronizar?anio=${ value }`);
    },

    metasHabilitadosPorEjecutora(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/metas/habilitados/ejecutora`);
    },

    metasHabilitadosPorEjecutoraYFecha(fecha){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/metas/habilitados/ejecutora/${fecha}`);
    },

    buscarMetaLocalizacion(meta){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/metas/localizacion/${meta}`);
    },

    getLocalizationByMetaAndDate(meta, fecha){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/metas/localizacion/meta?meta=${ meta }&fecha=${ fecha }`);
    },

    getMetasSelection(value){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/metas/seleccionar?anio=${ value }`);
    },

    /**
     * Proyectos
    */
    findAllProyectos(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos`); 
    },

    updateFromSiaf(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/actualizar/siaf`); 
    },

    updateFromSSI(cui){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/actualizar/ssi/${ cui }`); 
    },

    findProyectoById(cui){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/mostrar/${ cui }`); 
    },

    fetchUbicacion(value){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/ver/ubicacion/${ value }`); 
    },

    updateUbicacion(payload){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.put(`/v1/proyectos/editar/ubicacion/${ payload.cui }`, payload.data); 
    },

    fetchEstados(value){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/ver/estado/${ value }`); 
    },

    updateEstados(payload){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.put(`/v1/proyectos/editar/estado/${ payload.cui }`, payload.data); 
    },

    fetchModalidad(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/modalidades/seleccion`); 
    },

    actualizarUei(value){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.put(`/v1/proyectos/actualizar/uei/${ value }`); 
    },

    listarProvincia(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/provincias/seleccion`); 
    },

    listarDistritoPorProvincia(value){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/distritos/seleccion/${ value }`); 
    },

    listarUbicacionesProyecto(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/geolocalizacion`); 
    },

    listarAvanceProyecto(){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/avances`); 
    },

    listarUbicacionesProyectoPorCod(codigo){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/geolocalizacion/codigo/${ codigo }`); 
    },

    listarAvanceProyectoPorCod(codigo){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/avances/codigo/${ codigo }`); 
    },

    listarUbicacionPorProvincia(value){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/geolocalizacion/provincia/${ value }`); 
    },

    listarAvancePorProvincia(value){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/avances/provincia/${ value }`); 
    },

    listarUbicacionPorDistrito(value){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/geolocalizacion/distrito/${ value }`); 
    },

    listarAvancePorDistrito(value){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/proyectos/avances/distrito/${ value }`); 
    },

    /**
     * Monitoreo y Control
    */
    
    fetchActivityById(id){
        apiCliente.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        return apiCliente.get(`/v1/monitoreo/${id}`); 
    },

}

